import { render, staticRenderFns } from "./BasicView.vue?vue&type=template&id=1127ab78&scoped=true&"
import script from "./BasicView.vue?vue&type=script&lang=js&"
export * from "./BasicView.vue?vue&type=script&lang=js&"
import style0 from "./BasicView.vue?vue&type=style&index=0&id=1127ab78&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127ab78",
  null
  
)

export default component.exports